<template>
  <b-row>
    <b-col :sm="12">
      <h3>{{ $t("TRANSPORT") }}:</h3>
    </b-col>
    <b-col>
      <v-text-field
        :value="selectedTransportDocForwarderName"
        :label="$t('FORWARDER')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="globalTransportDoc.num"
        :label="$t('DOC_NUM')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="globalTransportDoc.date"
        :label="$t('DOC_DATE')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="globalTransportDoc.totalCurrency"
        :label="$t('TOTAL_PRICE')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="selectedTransportDocCurrencyCode"
        :label="$t('CURRENCY')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="selectedTransportDocVatRate"
        :label="$t('VAT_GROUPS')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
  </b-row>
</template>
<script>
import _ from "lodash";
export default {
  name: "PreviewTransportDocInfo",
  inheritAttrs: false,
  props: {
    firstLoader: {
      type: Boolean,
      default: true
    },
    selectedTransportDocForwarderName: {
      type: String,
      default: ""
    },
    stockActionTypeId: {
      type: Number,
      default: 1
    },
    vatGroups: {
      type: Array,
      default: function() {
        return [];
      }
    },
    currencies: {
      type: Array,
      default: function() {
        return [];
      }
    },
    globalTransportDoc: {
      type: Object,
      default: function() {
        return {
          visible: false,
          num: "",
          date: "",
          vatGroupId: 3,
          currencyId: 1,
          totalCurrency: "0.00"
        };
      }
    }
  },
  data() {
    return {};
  },
  components: {},
  mounted() {},
  computed: {
    tempFirstLoader: {
      get: function() {
        return this.firstLoader;
      },
      set: function(newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    selectedTransportDocCurrencyCode() {
      return this.selectedCurrencyCode(this.globalTransportDoc.currencyId);
    },
    selectedTransportDocVatRate() {
      return this.selectedVatRate(this.globalTransportDoc.vatGroupId);
    }
  },
  watch: {},
  methods: {
    selectedCurrencyCode(currencyId) {
      const currencyConst = _.find(this.currencies, { id: currencyId });
      if (currencyConst) {
        return currencyConst.code;
      } else {
        return "";
      }
    },
    selectedVatRate(vatGroupId) {
      const vatGroupConst = _.find(this.vatGroups, { id: vatGroupId });
      if (vatGroupConst) {
        return vatGroupConst.name;
      } else {
        return "";
      }
    }
  }
};
</script>
